import React from 'react';
import Navbar from '../HomeComponent/Navbar';
import FooterComponent from '../Footer/FooterComponent';

const PrivacyPolicy = () => {
    return (
        <>
            <Navbar />
            <div style={{ paddingTop: '120px', minHeight: '100vh', background: '#f8fafc', paddingBottom: '80px', fontFamily: "'Inter', sans-serif" }}>
                <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 24px' }}>

                    {/* Header */}
                    <div style={{ textAlign: 'center', marginBottom: '60px' }}>
                        <h1 style={{ fontSize: '3rem', fontWeight: '800', color: '#1e293b', marginBottom: '16px', letterSpacing: '-0.02em' }}>
                            Privacy Policy
                        </h1>
                        <p style={{ fontSize: '1.125rem', color: '#64748b' }}>
                            Last Updated: {new Date().toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })}
                        </p>
                    </div>

                    {/* Content Card */}
                    <div style={{ background: 'white', padding: '60px', borderRadius: '24px', boxShadow: '0 10px 40px -10px rgba(0,0,0,0.05)' }}>

                        <div style={{ marginBottom: '40px' }}>
                            <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#475569', marginBottom: '24px' }}>
                                At ToxBoxAI, we take your privacy seriously. This policy describes how we collect, use, and handle your information
                                when you use our AI services. We are committed to transparency and security.
                            </p>
                        </div>

                        <Section title="1. Information Collection">
                            <p>We facilitate better AI interactions by collecting basic information such as:</p>
                            <ul style={{ listStyleType: 'disc', paddingLeft: '24px', marginTop: '16px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                <li><strong>Identity Data:</strong> Name, username, or similar identifiers.</li>
                                <li><strong>Contact Data:</strong> Email address and telephone numbers.</li>
                                <li><strong>Technical Data:</strong> IP address, browser type and version, time zone setting, operating system and platform.</li>
                                <li><strong>Usage Data:</strong> Information about how you use our website and services.</li>
                            </ul>
                        </Section>

                        <Section title="2. How We Use Data">
                            <p>We use your data to provide, improve, and administer our Services, communicate with you, for security and fraud prevention, and to comply with law. We may also use your information for other purposes with your consent.</p>
                        </Section>

                        <Section title="3. Data Security">
                            <p>We have implemented appropriate technical and organizational security measures designed to protect the security of any personal information we process. However, please also do your part to help us.</p>
                        </Section>

                        <Section title="4. Sharing Information">
                            <p>We do not share your personal information with third parties unless it is necessary to provide our services, comply with the law, or protect our rights.</p>
                        </Section>

                        <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '30px', marginTop: '40px' }}>
                            <p style={{ fontSize: '0.95rem', color: '#94a3b8', fontStyle: 'italic' }}>
                                * This is a summary of our privacy practices. For full legal details, please contact our legal department.
                            </p>
                        </div>

                    </div>
                </div>
            </div>
            <FooterComponent />
        </>
    );
};

const Section = ({ title, children }) => (
    <section style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#0f172a', marginBottom: '16px' }}>{title}</h2>
        <div style={{ fontSize: '1.05rem', lineHeight: '1.7', color: '#475569' }}>
            {children}
        </div>
    </section>
);

export default PrivacyPolicy;
